import goto from "src/pageDefinitions/goto";
import { appDownloadLayer } from "src/pageDefinitions/goto/constants";
import { ActionHandler } from ".";

/** After membership medication selection, open app download. */
export const startAppDownload: ActionHandler = async () => {
  await goto.layer(appDownloadLayer);
};
